"use strict";const e=()=>({styleOverrides:{listbox:{padding:0}}});module.exports=e;
